import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Pannellum } from "pannellum-react";

const pannellumOptions = {
  width: "200px",
  height: "150px",
  autoLoad: true,
  orientationOnByDefault: false,
  showZoomCtrl: true,
  keyboardZoom: false,
  disableKeyboardCtrl: true,
  showFullscreenCtrl: false,
  showControls: false,
  draggable: false,
};

const Image = ({ index, image, onImageReceived }) => {
  const [img] = useState(image);
  const pannellumRef = useRef(null);

  const handleSceneLoaded = () => {
    const viewer = pannellumRef.current.getViewer();

    const capturedImage = viewer
      .getRenderer()
      .render(
        (viewer.getPitch() / 180) * Math.PI,
        (viewer.getYaw() / 180) * Math.PI,
        (viewer.getHfov() / 180) * Math.PI,
        { returnImage: true }
      );

    const covers = JSON.parse(
      sessionStorage.getItem("new-project-panorama-load-covers") || "[]"
    );

    covers[index] = capturedImage;

    sessionStorage.setItem(
      "new-project-panorama-load-covers",
      JSON.stringify(covers)
    );

    onImageReceived();
  };

  const currentImage = URL.createObjectURL(img);

  return (
    <div className="new-project-panorama-load-cover__image">
      <Pannellum
        id={`new-project-load-cover-${index}`}
        ref={pannellumRef}
        image={currentImage}
        {...pannellumOptions}
        pitch={0}
        yaw={0}
        onLoad={handleSceneLoaded}
      />
    </div>
  );
};

/**
 * To capture panorama image for using as covers
 * @param {} param0
 * @returns
 */
const LoadCover = ({ images: _images, onLoaded }) => {
  const [images] = useState(_images);

  useEffect(() => {
    sessionStorage.removeItem("new-project-panorama-load-covers");
    sessionStorage.setItem(
      "new-project-panorama-load-covers",
      JSON.stringify(images.map((_) => ""))
    );
  }, []);

  const handleOnImageReceived = (cover) => {
    const _covers = JSON.parse(
      sessionStorage.getItem("new-project-panorama-load-covers") || []
    );

    const missingImage = _covers.findIndex((c) => c === "");

    if (missingImage === -1) {
      sessionStorage.removeItem("new-project-panorama-load-covers");
      onLoaded(_covers);
    }
  };

  return (
    <div className="new-project-panorama-load-cover">
      <h1>Loading</h1>
      <div className="new-project-panorama-load-cover-list">
        {images.map((image, index) => (
          <Image
            index={index}
            key={`${index}`}
            image={image}
            onImageReceived={handleOnImageReceived}
          />
        ))}
      </div>
    </div>
  );
};

LoadCover.propTypes = {
  images: PropTypes.array,
};

export default LoadCover;
